import quartzScheduleList from "@/views/quartz/QuartzScheduleList";
import quartzScheduleEdit from "@/views/quartz/QuartzScheduleEdit";

const metaObject = { requiresAuth: true, roles: ['mmf'] };

export default [
    {
        path: "/quartz/quartzScheduleEdit",
        name: "quartzScheduleEdit",
        component: quartzScheduleEdit,
        meta: metaObject
    }, 
    {
        path: "/quartz/quartzSchedule",
        name: "quartzScheduleList",
        component: quartzScheduleList,
        meta: metaObject
    }
]